import { Profession } from "@/domains/notification/constants/profession";

export const porfessionTranslate: Record<Profession, string> = {
  [Profession.BusDriver]: "notification.busDriver",
};
